(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["syncbase-storefront-browser"] && !Shopify.designMode) return;
  try {
    const roots = document.querySelectorAll('[data-syncbase-storefront-root="true"]');

  roots.forEach((root) => {
    const searchEl = root.querySelector('.syncbase-storefront__search');
    const setFilterEl = root.querySelector('[data-filter-set]');
    const typeFilterEl = root.querySelector('[data-filter-type]');
    const searchButton = root.querySelector('.syncbase-storefront__search-button');
    const statusEl = root.querySelector('.syncbase-storefront__status');
    const checkoutButton = root.querySelector('.syncbase-storefront__checkout');
    const cartCountEl = root.querySelector('.syncbase-storefront__cart-count');
    const pageIndicatorEl = root.querySelector('[data-page-indicator]');
    const spreadEl = root.querySelector('[data-binder-spread]');
    const leftGridEl = root.querySelector('[data-page-grid="left"]');
    const rightGridEl = root.querySelector('[data-page-grid="right"]');
    const prevButton = root.querySelector('[data-binder-prev]');
    const nextButton = root.querySelector('[data-binder-next]');
    const dataEl = root.querySelector('.syncbase-storefront__data');

    if (!spreadEl || !leftGridEl || !rightGridEl || !dataEl) return;

    let parsedProducts = [];
    try {
      const maybeItems = JSON.parse(dataEl.textContent || '[]');
      if (Array.isArray(maybeItems)) parsedProducts = maybeItems;
    } catch (_err) {
      parsedProducts = [];
    }

    const state = {
      allProducts: parsedProducts.filter((item) => item && item.available === true && item.variantId),
      filteredProducts: [],
      query: '',
      selectedSet: '',
      selectedType: '',
      cart: new Map(),
      spreadIndex: 0,
      spreadMode: false,
      columns: 3,
      rows: 3,
      perPage: 9,
    };

    const setStatus = (text) => {
      if (!statusEl) return;
      statusEl.textContent = text || '';
    };

    const updateCartCount = () => {
      if (!cartCountEl) return;
      let totalItems = 0;
      state.cart.forEach((qty) => {
        totalItems += qty;
      });
      cartCountEl.textContent = String(totalItems);
    };

    const buildFilterOptions = () => {
      if (setFilterEl) {
        const values = Array.from(
          new Set(
            state.allProducts
              .map((item) => (item.setName || '').trim())
              .filter((value) => value.length > 0)
          )
        ).sort((a, b) => a.localeCompare(b));
        values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          setFilterEl.appendChild(option);
        });
      }

      if (typeFilterEl) {
        const values = Array.from(
          new Set(
            state.allProducts
              .map((item) => (item.cardType || '').trim())
              .filter((value) => value.length > 0)
          )
        ).sort((a, b) => a.localeCompare(b));
        values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          typeFilterEl.appendChild(option);
        });
      }
    };

    const createCardEl = (product) => {
      const card = document.createElement('article');
      card.className = 'syncbase-binder__card';

      const imageWrap = document.createElement('div');
      imageWrap.className = 'syncbase-binder__image-wrap';
      if (product.image) {
        const image = document.createElement('img');
        image.className = 'syncbase-binder__image';
        image.src = product.image;
        image.alt = product.title || '';
        image.loading = 'lazy';
        imageWrap.appendChild(image);
      }

      const title = document.createElement('p');
      title.className = 'syncbase-binder__title';
      title.textContent = product.title || 'Untitled card';

      const meta = document.createElement('div');
      meta.className = 'syncbase-binder__meta';

      const price = document.createElement('span');
      price.className = 'syncbase-binder__price';
      price.textContent = product.price || 'Unavailable';

      const addButton = document.createElement('button');
      addButton.type = 'button';
      addButton.className = 'syncbase-binder__add button button--secondary';
      addButton.textContent = 'Add';
      addButton.dataset.variant = String(product.variantId || 0);
      if (!product.variantId) {
        addButton.disabled = true;
      }

      meta.appendChild(price);
      meta.appendChild(addButton);

      card.appendChild(imageWrap);
      card.appendChild(title);
      card.appendChild(meta);
      return card;
    };

    const renderPageInto = (gridEl, pageIndex) => {
      gridEl.innerHTML = '';
      const start = pageIndex * state.perPage;
      const end = start + state.perPage;
      const pageProducts = state.filteredProducts.slice(start, end);

      if (pageProducts.length === 0) {
        const empty = document.createElement('p');
        empty.className = 'syncbase-binder__empty';
        empty.textContent = 'No cards on this page.';
        gridEl.appendChild(empty);
        return;
      }

      pageProducts.forEach((product) => {
        gridEl.appendChild(createCardEl(product));
      });
    };

    const getTotalPages = () => Math.max(1, Math.ceil(state.filteredProducts.length / state.perPage));

    const getTotalSpreads = () => {
      const totalPages = getTotalPages();
      return state.spreadMode ? Math.ceil(totalPages / 2) : totalPages;
    };

    const updateLayout = () => {
      const spreadWidth = spreadEl.clientWidth || window.innerWidth;
      const spreadHeight = spreadEl.clientHeight || 520;

      const isLandscape = window.matchMedia('(orientation: landscape)').matches;
      const isTabletUp = window.matchMedia('(min-width: 744px)').matches;
      state.spreadMode = isLandscape && isTabletUp;

      root.dataset.layout = state.spreadMode ? 'spread' : 'single';

      const pageWidth = state.spreadMode ? (spreadWidth - 12) / 2 : spreadWidth;
      const columns = Math.max(2, Math.min(4, Math.floor(pageWidth / 170)));
      const rows = Math.max(2, Math.min(4, Math.floor((spreadHeight - 24) / 210)));

      state.columns = columns;
      state.rows = rows;
      state.perPage = columns * rows;

      spreadEl.style.setProperty('--binder-columns', String(columns));
      spreadEl.style.setProperty('--binder-rows', String(rows));
    };

    const renderCurrentSpread = () => {
      const totalSpreads = getTotalSpreads();
      if (state.spreadIndex >= totalSpreads) {
        state.spreadIndex = totalSpreads - 1;
      }
      if (state.spreadIndex < 0) state.spreadIndex = 0;

      const leftPageIndex = state.spreadMode ? state.spreadIndex * 2 : state.spreadIndex;
      const rightPageIndex = leftPageIndex + 1;
      const totalPages = getTotalPages();

      renderPageInto(leftGridEl, leftPageIndex);
      if (state.spreadMode) {
        renderPageInto(rightGridEl, rightPageIndex);
      } else {
        rightGridEl.innerHTML = '';
      }

      if (prevButton) prevButton.disabled = state.spreadIndex <= 0;
      if (nextButton) nextButton.disabled = state.spreadIndex >= totalSpreads - 1;

      const shownCount = Math.min(
        state.filteredProducts.length,
        state.spreadMode ? (state.spreadIndex + 1) * state.perPage * 2 : (state.spreadIndex + 1) * state.perPage
      );
      setStatus(`Showing ${shownCount} of ${state.filteredProducts.length} in-stock cards`);

      if (pageIndicatorEl) {
        if (state.spreadMode) {
          const leftDisplay = leftPageIndex + 1;
          const rightDisplay = Math.min(rightPageIndex + 1, totalPages);
          pageIndicatorEl.textContent = `Pages ${leftDisplay}-${rightDisplay} of ${totalPages}`;
        } else {
          pageIndicatorEl.textContent = `Page ${leftPageIndex + 1} of ${totalPages}`;
        }
      }
    };

    const applyFilters = () => {
      const query = state.query.trim().toLowerCase();
      state.filteredProducts = state.allProducts.filter((product) => {
        const searchMatch = !query || String(product.search || '').toLowerCase().includes(query);
        const setMatch = !state.selectedSet || String(product.setName || '') === state.selectedSet;
        const typeMatch = !state.selectedType || String(product.cardType || '') === state.selectedType;
        return searchMatch && setMatch && typeMatch;
      });
      state.spreadIndex = 0;
      renderCurrentSpread();
    };

    searchButton?.addEventListener('click', () => {
      state.query = searchEl?.value || '';
      applyFilters();
    });

    searchEl?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      state.query = searchEl.value || '';
      applyFilters();
    });

    setFilterEl?.addEventListener('change', () => {
      state.selectedSet = setFilterEl.value || '';
      applyFilters();
    });

    typeFilterEl?.addEventListener('change', () => {
      state.selectedType = typeFilterEl.value || '';
      applyFilters();
    });

    prevButton?.addEventListener('click', () => {
      state.spreadIndex -= 1;
      renderCurrentSpread();
    });

    nextButton?.addEventListener('click', () => {
      state.spreadIndex += 1;
      renderCurrentSpread();
    });

    spreadEl.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      const button = target.closest('button[data-variant]');
      if (!(button instanceof HTMLButtonElement)) return;

      const variantId = Number(button.dataset.variant || '');
      if (!variantId) return;

      const nextQty = Number(state.cart.get(variantId) || 0) + 1;
      state.cart.set(variantId, nextQty);
      updateCartCount();
      setStatus('Added to cart');
    });

    checkoutButton?.addEventListener('click', () => {
      const lines = [];
      state.cart.forEach((qty, variantId) => {
        if (qty > 0) lines.push(`${variantId}:${qty}`);
      });
      if (lines.length === 0) {
        setStatus('Add at least one card first.');
        return;
      }
      window.location.href = `/cart/${lines.join(',')}`;
    });

    const rerenderForResize = () => {
      updateLayout();
      renderCurrentSpread();
    };

    window.addEventListener('resize', rerenderForResize);
    buildFilterOptions();
    updateCartCount();
    applyFilters();
    rerenderForResize();
  });
  } catch(e) { console.error(e); }
})();

})();
